<template>
  <Header>
    <Menu mode="horizontal" theme="dark" active-name="1">
      <div class="layout-logo">医诺数据中心接口平台(自用)</div>
      <div class="layout-nav">
        <MenuItem name="2">
          <Dropdown  @on-click="person">
            <a href="javascript:void(0)">
              <Icon type="md-person"/>
              {{$store.state.userName}}
            </a>
            <DropdownMenu slot="list">
              <DropdownItem>个人中心</DropdownItem>
              <DropdownItem name="exit">退出</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </MenuItem>
      </div>
    </Menu>
  </Header>
</template>
<script>
export default {
  name: "YnHeader",
  methods:{
    person(n){
      console.log(n);
      if(n==='exit'){
        localStorage.clear();
        this.$router.push("/");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.layout-logo {
  border-radius: 3px;
  float: left;
  color: #fff;
  font-size: 20px;
}
.layout-nav {
  float: right;
  margin: 0 auto;
  margin-right: 20px;
  a {
    color: #fff
  }
}
</style>




// WEBPACK FOOTER //
// src/views/index/YnHeader.vue